import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  ERROR_MESSAGE_DETAILS_PAGE__500_ALERT,
  ERROR_MESSAGE_DETAILS_PAGE__ALERT_EXPIRED,
} from '../../../../configurations/error-messages';
import { getAlertDetails } from '../../../../services/member/alerts';
import { ROUTE_MAP } from '../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../services/route/route-navigation';
import ControlButton, {
  SHAPES,
  SIZES,
  TYPES,
} from '../../../shared/_deprecated/components/ControlButton/ControlButton';
import HeaderBar from '../../../shared/_deprecated/features/HeaderBar/HeaderBar';
import DetailsPage from '../../DetailsPage/DetailsPage';

const AlertDetailsContainer = ({ id }) => {
  const history = useHistory();

  return (
    <DetailsPage
      headerBarContent={
        <HeaderBar
          leftNode={[
            <ControlButton
              key="button-close"
              action={() => history.push('/maps/notifications/alerts')}
              controlButtonType={TYPES.RETURN}
              shape={SHAPES.ROUND}
              size={SIZES.SMALLEST}
            />,
          ]}
          centerNode="Alert"
          rightNode={[
            <ControlButton
              key="button-close"
              action={() => transitionToNextRoute(ROUTE_MAP)}
              controlButtonType={TYPES.CLOSE}
              shape={SHAPES.ROUND}
              size={SIZES.SMALLEST}
            />,
          ]}
        />
      }
      fetchData={() => getAlertDetails(id)}
      errorMessage={ERROR_MESSAGE_DETAILS_PAGE__500_ALERT}
      expiredMessage={ERROR_MESSAGE_DETAILS_PAGE__ALERT_EXPIRED}
      sharingText="Check out this alert on Deckee!"
      sharingItemType="alert"
      sharingPathPrefix="alerts/details/"
      type="alert"
    />
  );
};

AlertDetailsContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

const mapDispatchToProps = () => ({});
const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertDetailsContainer);
